import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';

import {
  Field,
  FieldKinds,
  List,
  LogicRule,
  RegisterViewFieldSetting,
  YesNoValues,
} from '@site-mate/dashpivot-shared-library';

import { FormCategoryService } from 'app/form-fields/category/edit/form-category.service';

@Component({
  selector: 'cc-register-view-setting-field',
  templateUrl: './register-view-setting-field.component.html',
  styleUrls: ['./register-view-setting-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegisterViewSettingFieldComponent implements OnInit {
  @Input() fieldSetting: RegisterViewFieldSetting;
  @Input() fieldSettings: RegisterViewFieldSetting[];
  @Input() templateFields: { [key: string]: Field };
  @Input() metadataList: List[];
  @Output() onFieldSelectionChange = new EventEmitter<void>();

  disabledFields = [FieldKinds.PageBreak];

  logicRules: {
    rule: LogicRule;
    values: Observable<{ id: string; label: string }[]>;
    fields: RegisterViewFieldSetting[];
  }[] = [];

  templateField: Field;
  label: string;

  constructor(private readonly formCategoryService: FormCategoryService) {}

  ngOnInit(): void {
    this.templateField = this.templateFields[this.fieldSetting.itemId];
    this.label = this.getLabel();

    if (this.templateField?.logicRules) {
      this.logicRules = this.templateField.logicRules.map((rule) => {
        return {
          rule,
          values: this.loadLogicRuleValues(),
          fields: this.fieldSettings.filter(
            (field) => this.templateFields[field.itemId]?.dependsOn?.logicRuleId === rule.id,
          ),
        };
      });
    }

    this.checkForDisabledFields();
  }

  checkForDisabledFields() {
    const isDisabled = this.disabledFields.includes(this.templateField.kind);

    if (isDisabled) {
      this.fieldSetting = {
        ...this.fieldSetting,
        isDisabled,
        visible: !isDisabled,
      };
    }
  }

  getRuleValues(rule, values): string {
    return values
      .filter((value) => rule.values.includes(value.id))
      .map((value) => value.label)
      .join(', ');
  }

  private getLabel(): string {
    return this.templateField.kind === FieldKinds.YesNoCheckbox
      ? [this.templateField.content, this.templateField.description].filter(Boolean).join(' - ')
      : this.templateField.description;
  }

  private getYesNoNAOptions() {
    return Object.keys(YesNoValues).map((key) => ({ id: YesNoValues[key], label: key }));
  }

  private loadLogicRuleValues() {
    if (this.templateField?.kind === FieldKinds.Category) {
      return this.formCategoryService.getCategoryItems(this.templateField, this.metadataList, null);
    }

    return of(this.getYesNoNAOptions());
  }
}
